<!-- eslint-disable indent -->
<template>
  <div class="main" v-cloak>

    <div class="el-breadcrumbs">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>


        <el-breadcrumb-item v-if="this.$route.query.isPingPai"
          :to="{ path: '/pages/shop/brandlist?brand_id=' }">全部品牌</el-breadcrumb-item>

        <el-breadcrumb-item v-if="this.$route.query.name">{{this.$route.query.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="screen">
      <div class="left-title">
        筛选:
      </div>
      <div class="edit-main">
        <!-- <div class="multiple">
          综合
        </div> -->
        <div class="sales">
          <span @click="multipleClick">
            综合
          </span>
          <!-- <div class="sales-icons">
            <i class="el-icon-caret-top" :class="{ 'on': field==`sort`&&isMultiple }"></i>
            <i class="el-icon-caret-bottom" :class="{ 'on': field==`sort`&&!isMultiple }"></i>
          </div> -->
        </div>
        <div class="sales">
          <span @click="salesClick">
            销量
          </span>
          <div class="sales-icons">
            <i class="el-icon-caret-top" :class="{ 'on': field == `sales` && isSales }"></i>
            <i class="el-icon-caret-bottom" :class="{ 'on': field == `sales` && !isSales }"></i>
          </div>
        </div>
        <div class="sales">
          <span @click="priceClick">
            价格
          </span>
          <div class="sales-icons">
            <i class="el-icon-caret-top" :class="{ 'on': field == `sell_price` && isPrice }"></i>
            <i class="el-icon-caret-bottom" :class="{ 'on': field == `sell_price` && !isPrice }"></i>
          </div>
        </div>
      </div>
    </div>


    <div class="shop-list">
      <div class="shop-li" v-for="(item, index) in listData" @click="shopDetailTap(item)">
        <div class="logo">
          <img :src="item.pic" alt="" />
        </div>
        <div class="shop-text">
          <div class="name">
            {{ item.name }}
          </div>

          <div class="price-prve-xl">
            <div class="l-cont">
              <div class="price">
                ￥{{ item.sell_price||0 }}
              </div>
              <div class="hxj">
                ￥{{ item.market_price||0 }}
              </div>
            </div>
            <div class="xl-gm">
              {{item.sales||0}}人购买
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="pageEdit">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageObj.pageNum" :page-size="pageObj.pageSize" :total="pageObj.shopTotal">
      </el-pagination>
      <!-- layout="total, sizes, prev, pager, next, jumper" -->
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageObj: {
          pageSize: 20,
          shopTotal: 1000,
          pageNum: 1,
        },
        listData: [],
        // isMultiple: true,//综合排序
        isSales: false, //销量排序
        isPrice: false, //价格排序
        field: "",
        order: "",
        link_data: [],
      }
    },
    watch: {
      $route: {
        handler(newVal, oldVal) {
          this.getshopInfos();
        }
      }
    },
    mounted() {
      this.getshopInfos();
    },
    methods: {
      shopDetailTap(item) {
        this.$router.push({
          path: "/pages/shop/shopDetails",
          query: {
            id: item.id,
            cid: this.$route.query.cid,
            brand_id: this.$route.query.brand_id,
            name: this.$route.query.name,
            keyword: this.$route.query.keyword,
            isPingPai: this.$route.query.isPingPai,
          }
        })
      },
      priceClick() {
        this.isPrice = !this.isPrice;
        this.field = "sell_price";
        this.order = this.isPrice ? "asc" : "desc";
        this.getshopInfos();
      },
      salesClick() {
        this.isSales = !this.isSales;
        this.field = "sales";
        this.order = this.isSales ? "asc" : "desc";
        this.getshopInfos();
      },
      multipleClick() {
        //清空选择内容
        this.isSales = false;
        this.isPrice = false;
        this.field = "sort";
        this.order = "";
        this.getshopInfos();

        // this.isMultiple = !this.isMultiple;
        // this.field = "sort";
        // this.order = this.isMultiple ? "asc" : "desc";
        // this.getshopInfos();
      },
      getshopInfos() {
        this.$http.post('?s=/apiPc.Product/proList', {
            cid: this.$route.query.cid, //分类id
            pagenum: this.pageObj.pageNum, //分页
            keyword: this.$route.query.keyword, //搜索
            brand_id: this.$route.query.brand_id, //品牌id
            field: this.field, //排序方式字段
            order: this.order, //正序asc 倒序desc
          })
          .then(response => {
            this.listData = response.data.list;
            this.pageObj.shopTotal = response.data.total;
            this.link_data = response.data.link_data;
            console.log(this.link_data)
          })
          .catch(error => {});
      },
      handleCurrentChange(e) {
        this.pageObj.pageNum = e;
        this.getshopInfos()
      },
      handleSizeChange(e) {
        this.pageObj.pageSize = e;
        this.getshopInfos()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main {
    padding: 0 123px;
    background: #f5f5f5;
  }

  .main .el-breadcrumbs {
    padding-top: 30px;
  }

  .main .screen {
    display: flex;
    align-items: center;
    margin-left: 1%;
    padding-top: 30px;
    padding-bottom: 10px;
    user-select: none;
  }

  .main .screen .left-title {
    font-size: 16px;
    color: #333333;
  }

  .main .screen .edit-main .multiple {
    font-size: 16px;
    margin-left: 50px;
    cursor: pointer;
  }

  .main .screen .edit-main .sales span {
    font-size: 16px;
    margin-left: 50px;
    cursor: pointer;
  }

  .main .screen .edit-main {
    display: flex;
    align-items: center;
  }

  .main .screen .edit-main .sales {
    display: flex;
    align-items: center;
  }

  .main .screen .edit-main .sales .sales-icons {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .main .screen .edit-main .sales .sales-icons i {
    font-size: 16px;
    color: #888888;
  }

  .main .screen .edit-main .sales .sales-icons i:nth-child(1) {
    transform: translateY(3px);
  }

  .main .screen .edit-main .sales .sales-icons i:nth-child(2) {
    transform: translateY(-3px);
  }

  .main .screen .edit-main .sales .sales-icons .on {
    color: orange;
  }

  .main .pageEdit {
    display: flex;
    justify-content: center;
    padding: 30px 0 100px 0;
  }

  .main .shop-list {
    display: flex;
    flex-wrap: wrap;
  }

  .main .shop-list .shop-li {
    width: 18%;
    margin: 20px 1%;
    background: #FFFFFF;
    /* min-height: 320px; */
    cursor: pointer;
  }

  .main .shop-list .shop-li .logo {
    width: 100%;
    /* height: 256px; */
  }

  .main .shop-list .shop-li .shop-text {
    padding: 12px;
  }

  .main .shop-list .shop-li .shop-text .name {
    font-size: 16px;
    line-height: 24px;
    height: 50px;
    display: -webkit-box;
    overflow: hidden;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /*显示的行数*/
  }

  .main .shop-list .shop-li .shop-text .price-prve-xl {
    display: flex;
    align-items: center;
    justify-content: space-between;

  }

  .main .shop-list .shop-li .shop-text .price-prve-xl .l-cont {
    display: flex;
    align-items: flex-end;
  }

  .main .shop-list .shop-li .shop-text .price-prve-xl .xl-gm {
    font-size: 12px;
    color: #888888;
    line-height: 30px;
  }

  .main .shop-list .shop-li .shop-text .price-prve-xl .price {
    font-size: 18px;
    color: red;
    line-height: 34px;
    font-weight: bold;
  }

  .main .shop-list .shop-li .shop-text .price-prve-xl .hxj {
    font-size: 14px;
    color: #888888;
    line-height: 30px;
    text-decoration: line-through;
    margin-left: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/views/pages/shop/prolist.vue